const COMMON_ESCAPE = [
  "statement_descriptor",
  "statement_descriptor_suffix",
  "business_name",
  "descriptor",
  "mid_country_live",
  "mid_country_test",
  "whitelist_enabled",
  "predefinedCredentials"
];

type EscapeMap = Record<string, (isLive: boolean) => string[]>;

const GATEWAY_ESCAPE_KEYS: EscapeMap = {
  Stripe: (isLive) => [
    isLive ? "secret_key_live" : "secret_key_test",
  ],
  Pix: (isLive) => [
    ...(isLive ? ["name_live", "email_live"] : ["name_test", "email_test"]),
  ],
  Raypd: (isLive) => [
    ...(isLive
      ? ["access_key_live", "secret_key_live"]
      : ["access_key_test", "secret_key_test"]),
  ],
  Banwire: (isLive) => [isLive ? "username_live" : "username_test"],
  Valitor: (isLive) => [isLive ? "apikey_live" : "apikey_test"],
  Bambora: (isLive) =>
    isLive
      ? [
          "merchantId_live",
          "passcode_live",
          "hash_key_live",
          "recurring_passcode_live",
          "reporting_passcode_live",
          "batch_passcode_live",
          "subscription_passcode_live",
        ]
      : [
          "merchantId_test",
          "passcode_test",
          "hash_key_test",
          "recurring_passcode_test",
          "reporting_passcode_test",
          "batch_passcode_test",
          "subscription_passcode_test",
        ],
  Tangoindia: (isLive) =>
    isLive
      ? ["api_id_live", "api_key_live"]
      : ["api_id_test", "api_key_test"],
  CFGPayments: (isLive) => [isLive ? "secret_key_live" : "secret_key_test"],
  Capa: (isLive) =>
    isLive
      ? ["api_key_live", "webhook_secret_live"]
      : ["api_key_test", "webhook_secret_test"],
  Orionx: (isLive) =>
    isLive
      ? ["api_key_live", "secret_key_live"]
      : ["api_key_test", "secret_key_test"],
  Mauricio: (isLive) =>
    isLive
      ? ["client_id_live", "api_secret_live"]
      : ["client_id_test", "api_secret_test"],
  Blox: (isLive) => [isLive ? "api_key_live" : "api_key_test"],
  Terracall: (isLive) =>
    isLive
      ? ["client_id_live", "client_secret_live"]
      : ["client_id_test", "client_secret_test"],
  MyXspend: (isLive) =>
    isLive
      ? ["email_live", "password_live"]
      : ["email_test", "password_test"],
  Bennupay: (isLive) =>
    isLive
      ? ["secret_key_live", "brand_id_live"]
      : ["secret_key_test", "brand_id_test"],
  Xorapay: (isLive) =>
    isLive
      ? ["secret_key_live", "encryption_key_live", "webhook_hash_live"]
      : ["secret_key_test", "encryption_key_test", "webhook_hash_test"],
  Murkon: (isLive) =>
    isLive
      ? [
          "entity_login_live",
          "entity_pass_live",
          "entity_code_live",
          "entity_type_live",
          "terminal_id_live",
        ]
      : [
          "entity_login_test",
          "entity_pass_test",
          "entity_code_test",
          "entity_type_test",
          "terminal_id_test",
        ],
  "Changelly Fiat": (isLive) =>
    isLive
      ? [
          "public_api_key_live",
          "private_key_live",
          "provider_live",
          "wallet_address_live",
          "to_currency_live",
        ]
      : [
          "public_api_key_test",
          "private_key_test",
          "provider_test",
          "wallet_address_test",
          "to_currency_test",
        ],
  "Changelly Crypto": (isLive) =>
    isLive
      ? ["public_api_key_live", "private_key_live"]
      : ["public_api_key_test", "private_key_test"],
  Transvoucher: (isLive) =>
    isLive
      ? ["api_key_live", "api_secret_live"]
      : ["api_key_test", "api_secret_test"],
  DNSPay: (isLive) =>
    isLive
      ? ["endpoint_id_live", "merchant_key_live"]
      : ["endpoint_id_test", "merchant_key_test"],
  Gate2Way: (isLive) =>
    isLive
      ? [
          "api_key_live",
          "api_secret_live",
          "payment_method_live",
          "payout_payment_method_live",
        ]
      : [
          "api_key_test",
          "api_secret_test",
          "payment_method_test",
          "payout_payment_method_test",
        ],
  Payin: (isLive) => [isLive ? "api_key_live" : "api_key_test"],
  "Payouts Tech": (isLive) =>
    isLive
      ? [
          "client_key_live",
          "password_live",
          "brand_live",
          "payout_client_key_live",
          "payout_password_live",
          "payout_brand_live",
        ]
      : [
          "client_key_test",
          "password_test",
          "brand_test",
          "payout_client_key_test",
          "payout_password_test",
          "payout_brand_test",
        ],
  DirectPayment: (isLive) =>
    isLive
      ? ["mid_live", "gateway_live", "key_live"]
      : ["mid_test", "gateway_test", "key_test"],
  JDPay: (isLive) =>
    isLive
      ? ["merchant_id_live", "api_key_live", "bank_code_live"]
      : ["merchant_id_test", "api_key_test", "bank_code_test"],
  Portinax: (isLive) =>
    isLive
      ? ["merchant_key_live", "password_live"]
      : ["merchant_key_test", "password_test"],
  Paysvara: (isLive) =>
    isLive
      ? ["api_key_live", "publish_key_live", "profile_id_live","auth_type_live"]
      : ["api_key_test", "publish_key_test", "profile_id_test","auth_type_test"],
  Rpayz: (isLive) =>
    isLive
      ? ["api_key_live", "publish_key_live","profile_id_live" ,"auth_type_live"]
      : ["api_key_test", "publish_key_test", "profile_id_test","auth_type_test"],
  Paypap: (isLive) =>
    isLive
      ? ["api_key_live", "secret_key_live", "client_id_live"]
      : ["api_key_test", "secret_key_test", "client_id_test"],
  Payporto: (isLive) =>
    isLive
      ? ["api_key_live"]
      : ["api_key_test"],
  Citigate: (isLive) =>
    isLive
      ? ["merchant_name_live","merchant_password_live"]
      : ["merchant_name_test","merchant_password_test"],
  "Re-set": (isLive) =>
    isLive
      ? ["secretKey_live", "brand_id_live"]
      : ["secretKey_test", "brand_id_test"],
  Scipiopay: (isLive) =>
    isLive
      ? ["shop_secret_key_live", "shop_id_live"]
      : ["shop_id_test", "shop_secret_key_test"],
  Betapay: (isLive) =>
    isLive
      ? ["api_token_live", "merchant_id_live", "terminal_id_live"]
      : ["api_token_test", "merchant_id_test", "terminal_id_test"],
  "Aurea Via": (isLive) =>
    isLive
      ? ["companyNum_live", "personalHashkey_live"]
      : ["companyNum_test", "personalHashkey_test"],
  Kasha: (isLive) =>
    isLive
      ? ["api_key_live", "merchant_domain_live"]
      : ["api_key_test", "merchant_domain_test"],
  Supefina: (isLive) => [isLive ? "merchant_id_live" : "merchant_id_test"],
  "3xpay": (isLive) =>
    isLive
      ? ["api_key_live", "api_secret_live"]
      : ["api_key_test", "api_secret_test"],
  "Platy 2DS": (isLive) =>
    isLive
      ? [
          "api_key_live",
          "password_live",
          "platy_api_key_live",
          "platy_secret_key_live",
          "username_live",
        ]
      : [
          "api_key_test",
          "password_test",
          "platy_api_key_test",
          "platy_secret_key_test",
          "username_test",
        ],
  "Platy 3DS": (isLive) =>
    isLive
      ? [
          "api_key_live",
          "password_live",
          "platy_api_key_live",
          "platy_secret_key_live",
          "username_live",
        ]
      : [
          "api_key_test",
          "password_test",
          "platy_api_key_test",
          "platy_secret_key_test",
          "username_test",
        ],
  Masterpay: (isLive) => [
    isLive ? "merchant_private_key_live" : "merchant_private_key_test",
  ],
  Neonpay: (isLive) =>
    isLive
      ? ["merchant_key_live", "password_live"]
      : ["merchant_key_test", "password_test"],
  Bm2pay: (isLive) =>
    isLive
      ? ["client_id_live", "client_secret_live"]
      : ["client_id_test", "client_secret_test"],
  TestGateway: (_isLive) => [],
};

export function getEscapeKeys(gatewayType: string, isLive: boolean): string[] {
  const fn = GATEWAY_ESCAPE_KEYS[gatewayType];
  const gatewayKeys = fn ? fn(isLive) : [];
  return [...COMMON_ESCAPE, ...gatewayKeys];
}